import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { sellerApi } from 'src/app/config';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class CreatePromotionService {
  constructor(private apiService: ApiService) {}

  ciscoAdminChallenge = new BehaviorSubject<any>(null);

  setCiscoAdminData(data: any): void {
    this.ciscoAdminChallenge.next({ editData: data });
  }

  getCiscoAdminData(): Observable<any> {
    return this.ciscoAdminChallenge.asObservable();
  }

  getCreationPromotionData(): Observable<any> {
    let challengeData = this.ciscoAdminChallenge.value;
    if (challengeData != null && challengeData.editData != null && !challengeData.editData.hasOwnProperty('copy')) {
      return this.apiService.get(sellerApi.customChallenge + this.ciscoAdminChallenge.value.editData['id']);
    } else if (challengeData != null && challengeData.editData != null && challengeData.editData.hasOwnProperty('copy')) {
      return this.apiService.get(sellerApi.cloneChallenge + this.ciscoAdminChallenge.value.editData['id']);
    } else {
      return this.apiService.get(sellerApi.customChallenge + 'new');
    }
  }

  submitCustomSalesChallenge(customeChallenge: any): Observable<any> {
    let challengeData = this.ciscoAdminChallenge.value;
    if (challengeData != null && challengeData.editData != null && !challengeData.editData.hasOwnProperty('copy')) {
      return this.apiService.put(
        `${sellerApi.submitCustomChallenge}/${this.ciscoAdminChallenge.value.editData['id']}`,
        customeChallenge
      );
    }
    if (challengeData != null && challengeData.editData != null && challengeData.editData.copy) {
      customeChallenge.status = 'DRAFT';
    }
    return this.apiService.post(
      sellerApi.submitCustomChallenge,
      customeChallenge
    );
  }

  getTrainingActivityData(startDate: string, endDate: string, regions: string): Observable<any> {
    return this.apiService.get(
      `${sellerApi.activityChallenge}?startDate=${startDate}&endDate=${endDate}&challengeType=4&regions=${regions}`
    );
  }
}
